import { Link } from "react-router-dom";
import { Check, X } from "lucide-react";
import Reveal from "@/components/Reveal";
import { useLang } from "@/i18n";

const MODELS = [
  { name: "AIR FORCE ONE LIFE", tag: { it: "Abitazioni & Uffici", en: "Homes & Offices" } },
  { name: "AIR FORCE ONE", tag: { it: "Professionale", en: "Professional" } },
  { name: "AIR FORCE ONE PRO MAX", tag: { it: "Grandi Ambienti", en: "Large Spaces" } },
];

const ROWS = [
  { l: { it: "CADR", en: "CADR" }, v: ["1200 m³/h", "750 m³/h", "2500 m³/h"] },
  { l: { it: "Copertura", en: "Coverage" }, v: [{ it: "fino a 170 m²", en: "up to 170 m²" }, { it: "fino a 170 m²", en: "up to 170 m²" }, { it: "fino a 355 m²", en: "up to 355 m²" }] },
  { l: { it: "Filtro HEPA", en: "HEPA filter" }, v: [{ it: "H13 (H14 opz.)", en: "H13 (H14 opt.)" }, { it: "H13 (H14 opz.)", en: "H13 (H14 opt.)" }, "H14"] },
  { l: { it: "Lampada UV", en: "UV lamp" }, v: [false, true, true] },
  { l: { it: "Umidificazione", en: "Humidification" }, v: [false, true, false] },
  { l: { it: "Ionizzatore", en: "Ioniser" }, v: [true, true, true] },
  { l: { it: "Sensori & App", en: "Sensors & App" }, v: [true, true, true] },
  { l: { it: "Consumo", en: "Power" }, v: ["23–145 W", "23–145 W", "40–230 W"] },
  { l: { it: "Rumorosità", en: "Noise" }, v: ["19–55 dB", "30–69 dB", "—"] },
  { l: { it: "Peso", en: "Weight" }, v: ["19,2 kg", "19,2 kg", "35 kg"] },
];

export const CompareTable = () => {
  const { tr } = useLang();

  const cell = (v) => {
    if (v === true) return <Check size={16} className="text-[#007A8A] inline" aria-label="sì" />;
    if (v === false) return <X size={16} className="text-[#52525b] inline" aria-label="no" />;
    return <span>{tr(v)}</span>;
  };

  return (
    <Reveal>
      <div className="overflow-x-auto border border-[#e4e4e7]" data-testid="compare-table">
        <table className="w-full min-w-[720px] text-sm font-body">
          <thead>
            <tr className="bg-[#f4f4f5]">
              <th className="text-left p-5 font-mono text-[10px] tracking-[0.3em] uppercase text-[#52525b] border-b border-[#e4e4e7] w-[22%]">
                {tr({ it: "— CONFRONTO", en: "— COMPARISON" })}
              </th>
              {MODELS.map((m) => (
                <th key={m.name} className="text-left p-5 border-b border-l border-[#e4e4e7] align-bottom">
                  <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#3f3f46] mb-2">
                    {tr(m.tag)}
                  </div>
                  <div className="font-display text-lg md:text-xl tracking-tighter text-[#0a0a0a] leading-tight">
                    {m.name}
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {ROWS.map((r, i) => (
              <tr key={i} className={i % 2 ? "bg-[#f4f4f5]/50" : ""}>
                <td className="p-4 font-mono text-[10px] tracking-widest uppercase text-[#3f3f46] border-b border-[#e4e4e7]">
                  {tr(r.l)}
                </td>
                {r.v.map((v, j) => (
                  <td key={j} className="p-4 border-b border-l border-[#e4e4e7] text-[#0a0a0a]">
                    {cell(v)}
                  </td>
                ))}
              </tr>
            ))}
            <tr className="bg-[#f4f4f5]">
              <td className="p-5 font-mono text-[10px] tracking-widest uppercase text-[#007A8A]">
                {tr({ it: "Prezzo", en: "Price" })}
              </td>
              {MODELS.map((m) => (
                <td key={m.name} className="p-5 border-l border-[#e4e4e7]">
                  <div className="font-body text-sm text-[#3f3f46]">
                    {tr({ it: "Su preventivo personalizzato", en: "On personalised quote" })}
                  </div>
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>
      <div className="mt-3 font-body text-xs text-[#52525b]" data-testid="compare-coverage-note">
        {tr({
          it: "Copertura calcolata come nel preventivo: 3 ricambi d'aria/ora con soffitto di 3 m (5 ricambi/ora in caso di asma).",
          en: "Coverage calculated as in the quote: 3 air changes/hour with a 3 m ceiling (5 changes/hour for asthma).",
        })}
      </div>
      <div className="mt-8 flex flex-wrap gap-4">
        <Link to="/preventivo" className="btn-primary" data-testid="compare-cta-quote">
          {tr({ it: "Richiedi preventivo", en: "Request a quote" })} →
        </Link>
        <Link to="/prova-a-casa" className="btn-ghost" data-testid="compare-cta-trial">
          {tr({ it: "Prova a casa con un tecnico", en: "Home trial with a technician" })}
        </Link>
      </div>
    </Reveal>
  );
};
